<script>
import MainLayout from '../layouts/mainLayout'
import googleMap from '@/components/googleMap'
import {DateUtil} from '@/utils/date.js'
import moment from 'moment'
import msgMP3 from '@/assets/mp3/dingdong.mp3'
import tblMP3 from '@/assets/mp3/trouble.mp3'
import MovementDetailedConfirm from '@/components/MovementDetailedConfirm'
import dialog from '@/components/Dialog'
import $ from 'jquery'
// import {CommonConstant} from '@/utils/CommonConstant.js'
import STATION_ICON_1 from '../../assets/map_icon/map_stop_point1.png'
import USER_ICON_1 from '../../assets/map_icon/map_transit_point1.png'
import STATION_ICON_2 from '../../assets/map_icon/map_stop_point2.png'
import USER_ICON_2 from '../../assets/map_icon/map_transit_point2.png'

import STATION_NO_ICON_1 from '../../assets/map_icon/map_non_stop_point1.png'
import STATION_NO_ICON_2 from '../../assets/map_icon/map_non_stop_point2.png'

import NORMAL_POSITION_ICON from '../../assets/map_icon/map_car_position.png'
// import BA_HOUR_POSITION_ICON from '../../assets/map_icon/map_car_position.png'
import RADIO_TROUBLE_POSITION_ICON from '../../assets/map_icon/map_car_gps_not_reach.png'
import TROUBLE_POSITION_ICON from '../../assets/map_icon/map_car_in _trouble.png'
import DELAY_POSITION_ICON from '../../assets/map_icon/map_car_delay.png'
import Stomp from 'stompjs'
import {CommonConstant} from '@/utils/CommonConstant.js'
export default {
  // 挂载之前获取数据
  beforeMount () {
    this.beforeMountFunc()
    // let shiftId = this.$route.query.shiftId

    // this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: shiftId}})
    //   .then(response => {
    //     this.shiftInfo = response.data.shiftInfo
    //     console.log(this.shiftInfo)

    //     let mqConfiguration = response.data.mqConfiguration
    //     this.MQ_URL = mqConfiguration.mqUrl
    //     this.MQ_LOGIN = mqConfiguration.mqUserName
    //     this.MQ_PASSCODE = mqConfiguration.mqPassword
    //     this.MQ_DESTINATION = mqConfiguration.mqDestination
    //     this.MQ_TIME_OUT = mqConfiguration.communicationTimeOut
    //     // 取MQ消息
    //     this.getMQMess()
    //     this.prepareData()

    //     setInterval(() => {
    //       if (this.vehicleMarker) {
    //         let nowTime = moment().format('YYYYMMDDHHmmssSSS')
    //         if (this.vehiclePoint.tTime && this.isTimeOut(this.vehiclePoint.tTime, nowTime) === false) {
    //           this.vehiclePoint.communicationFlag = 0
    //         } else if (this.isTimeOut(this.vehiclePoint.pTime, nowTime) || this.isTimeOut(this.vehiclePoint.mTime, nowTime)) {
    //           this.vehiclePoint.communicationFlag = 1
    //         } else {
    //           this.vehiclePoint.communicationFlag = 0
    //         }
    //         this.drawVehiclePoint()
    //       }
    //     }, 20 * 1000)
    //     console.log(this.shiftPasspoints)
    //     for(let i = 0; i < this.shiftPasspoints.length; i++){
    //       this.shiftPasspoints[i].connectList = []
    //     }
    //     this.setConnectList()
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  data () {
    return {
      functionId: 'MovementStatusDetail',
      mapId: 'mapMovementStatusDetail',
      // 地图中心点
      centerPoint: {
        lat: null,
        lng: null
      },
      // 地圖點
      markers: null,
      infowindowList: [],
      // 停留所ICON
      stationIcon: null,
      // 自宅地图选ICON
      userIcon: null,
      // 未停車ICON
      noStopIcon: null,
      // label样式
      labelClass: null,
      // 车点
      vehiclePoint: null,
      vehicleMarker: null,
      // 地图标记点List
      pointDataList: [],
      // shiftInfo结构
      shiftInfo: {
        title: '',
        shiftReservationInfos: [],
        shiftPasspoints: [
          {
            startEstimateTime: '',
            stationName: '',
            address: '',
            arriveActualTime: ''
          }
        ]
      },
      // 运行状况
      shiftMovementStatus: [
        '業務前',
        '業務中',
        '業務終了',
        '強制終了'
      ],
      // 预约
      shiftReservation: {},
      // 经由地点集
      shiftPasspoints: [],
      sums: 3,
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: 'この予約はキャンセル待ちとなります<br/>予約を続けますか？',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 延迟Dialog
      showDelayDialog: false,
      dialogDelayOption: {
        showNo: true,
        text: '運行中の' + '' + 'が<br/>遅延で遅れることを乗客にお知らせしますか？',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 强制终了Dialog
      showEndDialog: false,
      dialogEndOption: {
        showNo: true,
        text: 'この便を強制的に運行終了させます<br/>よろしいですか？',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 返回按钮名
      backName: '運行状況一覧に戻る',
      titleBg: [
        'bgc1',
        'bgc4',
        'bgc3',
        'bgc3'
      ],
      contentBg: [
        'bgc7',
        'bgc7',
        'bgc2',
        'bgc2'
      ],
      // 电波障害标志
      communicationFlag: 0,
      // 显示电波障害图标
      showGpsNotReach: false,
      // MQ URL
      MQ_URL: '',
      // MQ 登录名
      MQ_LOGIN: '',
      // MQ 登录密码
      MQ_PASSCODE: '',
      // MQ 队列名
      MQ_DESTINATION: '',
      // 超时时间
      MQ_TIME_OUT: 0,
      // MQ 客户端
      client: null,
      // 接続一覧
      shiftConnectList: [],
      // 接続されているすべての便が編集可能かどうか true:可能
      allConnectShiftsCanEdit: true
    }
  },
  computed: {
    status: function () {
      return this.checkMoveShiftStatus(this.shiftInfo)
    }
  },
  mounted () {
    console.log("mounted")
    console.log(this.shiftPasspoints)
  },
  components: {MainLayout, googleMap, MovementDetailedConfirm, 'v-dialog': dialog},
  watch: {
    communicationFlag: function () {
      if (this.communicationFlag === 1 && this.shiftInfo.lateFlag !== 1) {
        this.showGpsNotReach = true
      } else {
        this.showGpsNotReach = false
      }
    },
    '$route'(to,from){
      this.beforeMountFunc()
    }
  },
  methods: {
    beforeMountFunc(){
      let shiftId = this.$route.query.shiftId

      this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: shiftId}})
        .then(response => {
          this.shiftInfo = response.data.shiftInfo
          console.log(this.shiftInfo)

          let mqConfiguration = response.data.mqConfiguration
          this.MQ_URL = mqConfiguration.mqUrl
          this.MQ_LOGIN = mqConfiguration.mqUserName
          this.MQ_PASSCODE = mqConfiguration.mqPassword
          this.MQ_DESTINATION = mqConfiguration.mqDestination
          this.MQ_TIME_OUT = mqConfiguration.communicationTimeOut
          // 取MQ消息
          this.getMQMess()
          this.prepareData()

          setInterval(() => {
            if (this.vehicleMarker) {
              let nowTime = moment().format('YYYYMMDDHHmmssSSS')
              if (this.vehiclePoint.tTime && this.isTimeOut(this.vehiclePoint.tTime, nowTime) === false) {
                this.vehiclePoint.communicationFlag = 0
              } else if (this.isTimeOut(this.vehiclePoint.pTime, nowTime) || this.isTimeOut(this.vehiclePoint.mTime, nowTime)) {
                this.vehiclePoint.communicationFlag = 1
              } else {
                this.vehiclePoint.communicationFlag = 0
              }
              this.drawVehiclePoint()
            }
          }, 20 * 1000)
          console.log(this.shiftPasspoints)
          this.shiftConnectList = []
          for(let i = 0; i < this.shiftPasspoints.length; i++){
            this.shiftPasspoints[i].connectList = []
          }
          this.setConnectList()
        })
        .catch(error => {
          console.log(error)
        })
    },
    prepareData (mqFlag) {
      this.shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftInfo.moveShiftTime)
      let shiftPasspoints = this.shiftInfo.shiftPasspoints
      let sps = []
      let labelClassFlag = -1
      if (shiftPasspoints.length !== 0) {
        let stopObj = this.isStop(shiftPasspoints[0].stationId)

        let startPassengers = stopObj.startPassengers
        let arrivePassengers = stopObj.arrivePassengers
        let startPointPassengers = stopObj.startPassengers
        let arrivePointPassengers = stopObj.arrivePassengers
        let showPassengers = false
        if (startPassengers.length > 0) {
          showPassengers = true
        }
        // 設置起始點ICON樣式
        let icon = ''
        let labelClass = ''
        // 业务结束图标为灰色
        if (this.shiftInfo.businessStatus === 3) {
          icon = STATION_ICON_2
          labelClass = 'station-label-class-2'
        } else {
          icon = STATION_ICON_1
          labelClass = 'station-label-class-1'
        }
        if (shiftPasspoints[0].arriveActualTime) {
          labelClassFlag = 0
        }
        // 添加起始S
        sps.push(
          {
            // 一览的index序号
            listIndex: 'S',
            // 便の详细的路的序号
            index: 'S',
            estimateTime: shiftPasspoints[0].startEstimateTime !== null ? shiftPasspoints[0].startEstimateTime : this.shiftInfo.startEstimateTimeSlot,
            name: shiftPasspoints[0].stationName,
            address: shiftPasspoints[0].address,
            actualTime: shiftPasspoints[0].arriveActualTime,
            stopFlag: true,
            routeType: shiftPasspoints[0].routeType,
            stationId: shiftPasspoints[0].stationId,
            displayStationId: shiftPasspoints[0].displayStationId,
            stationLat: shiftPasspoints[0].stationLat,
            stationLng: shiftPasspoints[0].stationLng,
            passengerNameKana: '',
            reserveId: '',
            startPassengers: startPassengers,
            arrivePassengers: arrivePassengers,
            showPassengers: showPassengers,
            icon: icon,
            stationNote: shiftPasspoints[0].stationNote,
            startPointPassengers: startPointPassengers,
            arrivePointPassengers: arrivePointPassengers,
            labelClass: labelClass,
            officeFlag: shiftPasspoints[0].officeFlag,
            displayFlag: shiftPasspoints[0].displayFlag
          }
        )
        // 一般情况
        let listIndex = -1
        let houselistIndex = 0
        let houseIndex = 0
        let gIndex = 0
        for (let shiftPasspoint of shiftPasspoints) {
          listIndex++
          if (listIndex === 0) continue
          let splistIndex = ''
          let spIndex = ''
          if (listIndex === shiftPasspoints.length - 1) {
            spIndex = splistIndex = 'G'
          } else if (shiftPasspoint.routeType === '0') {
            spIndex = 'G' + (++gIndex)
          } else {
            spIndex = '' + (++houseIndex)
          }

          let name = ''
          let nameKana = ''
          let addressObj = null
          let stopFlag = false
          // 設置點ICON樣式
          let icon = ''
          // 停留所的上下车人
          let startPassengers = []
          let arrivePassengers = []
          // 上下车人
          let startPointPassengers = []
          let arrivePointPassengers = []
          // 預定時間
          let note = ''
          if (shiftPasspoint.routeType === '1') {
            let nameObj = this.getPassengerNameObj(shiftPasspoint.reserveId)
            name = nameObj.name
            nameKana = nameObj.nameKana
            note = nameObj.reservationNote
            // estimateTime = nameObj.estimateTime
            addressObj = this.getPassengerAddressObj(shiftPasspoint.reserveId)
            stopFlag = true
            addressObj.displayFlag = shiftPasspoint.displayFlag
            if (this.shiftInfo.shiftFlag === 0) {
              startPointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
            } else {
              arrivePointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
            }
          } else {
            // estimateTime = shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot
            name = shiftPasspoint.stationName
            note = shiftPasspoint.stationNote
            addressObj = {address: shiftPasspoint.address, stationId: shiftPasspoint.stationId, lat: shiftPasspoint.stationLat, lng: shiftPasspoint.stationLng, officeFlag: shiftPasspoint.officeFlag, displayFlag: shiftPasspoint.displayFlag}
            let stopObj = this.isStop(shiftPasspoint.stationId)
            stopFlag = stopObj.stopFlag
            startPassengers = stopObj.startPassengers
            arrivePassengers = stopObj.arrivePassengers
            startPointPassengers = stopObj.startPassengers
            arrivePointPassengers = stopObj.arrivePassengers
          }
          if (listIndex === shiftPasspoints.length - 1) {
            stopFlag = true
          }
          // 是否顯示同乘者
          let showPassengers = false
          if (shiftPasspoint.routeType === '0' && stopFlag && startPassengers.length > 0 && shiftPasspoint.displayFlag === 1) {
            showPassengers = true
          }

          if (!splistIndex && stopFlag && shiftPasspoint.displayFlag === 1) {
            splistIndex = '' + (++houselistIndex)
          }

          // 設置ICON樣式
          if (this.shiftInfo.businessStatus === 3) {
            labelClass = 'station-label-class-2'
            if (stopFlag === false && shiftPasspoint.displayFlag === 0) {
              icon = STATION_NO_ICON_2
            } else if (shiftPasspoint.routeType === '0') {
              icon = STATION_ICON_2
            } else {
              icon = USER_ICON_2
            }
          } else {
            labelClass = 'station-label-class-1'
            if (stopFlag === false && shiftPasspoint.displayFlag === 0) {
              icon = STATION_NO_ICON_1
            } else if (shiftPasspoint.routeType === '0') {
              icon = STATION_ICON_1
            } else {
              icon = USER_ICON_1
            }
          }
          if (shiftPasspoint.arriveActualTime) {
            labelClassFlag = listIndex
          }
          sps.push(
            {
              listIndex: splistIndex,
              index: spIndex,
              estimateTime: shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot,
              name: name,
              address: addressObj.address,
              actualTime: shiftPasspoint.arriveActualTime,
              stopFlag: stopFlag,
              routeType: shiftPasspoint.routeType,
              stationId: addressObj.stationId,
              displayStationId: shiftPasspoint.displayStationId,
              stationLat: addressObj.lat,
              stationLng: addressObj.lng,
              passengerNameKana: nameKana,
              reserveId: shiftPasspoint.reserveId,
              startPassengers: startPassengers,
              arrivePassengers: arrivePassengers,
              showPassengers: showPassengers,
              icon: icon,
              stationNote: note,
              startPointPassengers: startPointPassengers,
              arrivePointPassengers: arrivePointPassengers,
              labelClass: labelClass,
              officeFlag: addressObj.officeFlag,
              displayFlag: addressObj.displayFlag
            }
          )
        }
      }
      // 設置到達ICON樣式
      for (let i = 0; i <= labelClassFlag; i++) {
        sps[i].labelClass = 'station-label-class-2'
        if (i === 0) {
          sps[i].icon = STATION_ICON_2
          continue
        }
        if (sps[i].stopFlag === false && sps[i].displayFlag === 0) {
          sps[i].icon = STATION_NO_ICON_2
        } else if (sps[i].routeType === '0') {
          sps[i].icon = STATION_ICON_2
        } else {
          sps[i].icon = USER_ICON_2
        }
      }

      this.shiftPasspoints = sps
      this.pointDataList = []
      // 画点
      let passPoints = []
      let stopPoints = []
      new Promise((resolve, reject) => {
        for (let shiftPasspoint of this.shiftPasspoints) {
          if (shiftPasspoint.stopFlag === true && shiftPasspoint.displayFlag === 1) {
            // 画点点
            this.pointDataList.push({
              stationId: shiftPasspoint.listIndex,
              stationLat: shiftPasspoint.stationLat,
              stationLng: shiftPasspoint.stationLng,
              icon: shiftPasspoint.icon,
              labelClass: shiftPasspoint.labelClass,
              iconSize: {width: 45, height: 60},
              labelAnchor: {width: 22, height: 50}
            })
            stopPoints.push({
              shiftId: null,
              label: null,
              lat: shiftPasspoint.stationLat,
              lng: shiftPasspoint.stationLng,
              // 点的图标
              icon: shiftPasspoint.icon,
              iconSize: {
                width: 20,
                height: 20
              }
            })
          } else if(shiftPasspoint.stopFlag === false && shiftPasspoint.displayFlag === 1) {
            this.pointDataList.push({
              stationId: null,
              stationLat: shiftPasspoint.stationLat,
              stationLng: shiftPasspoint.stationLng,
              icon: shiftPasspoint.icon,
              labelClass: shiftPasspoint.labelClass,
              iconSize: {width: 20, height: 20},
              labelAnchor: {width: 20, height: 20}
            })
            stopPoints.push({
              shiftId: null,
              label: null,
              lat: shiftPasspoint.stationLat,
              lng: shiftPasspoint.stationLng,
              // 点的图标
              icon: shiftPasspoint.icon,
              iconSize: {
                width: 20,
                height: 20
              }
            })
          }
          // 画线点
          passPoints.push({
            lat: shiftPasspoint.stationLat,
            lng: shiftPasspoint.stationLng
          })
          // 画车点
          if (this.shiftInfo.businessStatus === 2 && this.shiftInfo.vehicleLat && this.shiftInfo.vehicleLng) {
            // 判断车辆的状态
            let icon
            // 通信故障标志 1为通信障害 0为通信正常

            let communicationFlag = 0
            if (mqFlag) {
              communicationFlag = 0
            } else {
              if (this.shiftInfo.positionUpdateTime && this.shiftInfo.positionUpdateTime.length === 17) {
                let updateTime = moment(this.shiftInfo.positionUpdateTime, 'YYYYMMDDHHmmssSSS')
                updateTime.add(this.MQ_TIME_OUT, 'seconds')
                if (updateTime.isBefore(new Date())) {
                  communicationFlag = 1
                }
              }
            }
            let iconSize
            if (communicationFlag === 1) {
              icon = RADIO_TROUBLE_POSITION_ICON
              iconSize = {
                width: 60,
                height: 85
              }
            } else if (this.shiftInfo.lateFlag === 1) {
              icon = DELAY_POSITION_ICON
              iconSize = {
                width: 60,
                height: 120
              }
            } else if (this.shiftInfo.troubleFlag === 1) {
              icon = TROUBLE_POSITION_ICON
              iconSize = {
                width: 60,
                height: 120
              }
            } else {
              icon = NORMAL_POSITION_ICON
              iconSize = {
                width: 60,
                height: 85
              }
            }
            this.vehiclePoint = {
              shiftId: this.shiftInfo.shiftId,
              label: null,
              lat: this.shiftInfo.vehicleLat,
              lng: this.shiftInfo.vehicleLng,
              // 延迟标志 1延迟 0正常
              lateFlag: this.shiftInfo.lateFlag,
              // 故障标志 1故障 0正常
              troubleFlag: this.shiftInfo.troubleFlag,
              // 是否更新 用于判断通信是否成功
              communicationFlag: communicationFlag,
              // 位置更新时间
              pTime: this.shiftInfo.positionUpdateTime,
              // MQ接收时间
              mTime: moment().format('YYYYMMDDHHmmssSSS'),
              // 故障时间
              tTime: null,
              // 点的图标
              icon: icon,
              iconSize: iconSize
            }
          }
        }
        resolve()
      }).then(() => {
        this.$refs.gMap.initializeGoogleMap().then(() => {
          // 初始化中心点
          this.centerPoint = {
            lat: (this.pointDataList[0].stationLat + this.pointDataList[this.pointDataList.length - 1].stationLat) / 2,
            lng: (this.pointDataList[0].stationLng + this.pointDataList[this.pointDataList.length - 1].stationLng) / 2
          }

          this.$refs.gMap.map.setZoom(14)

          this.markers = this.$refs.gMap.addMark()

          // 画车点
          if (this.shiftInfo.businessStatus === 2 && this.vehiclePoint) {
            let imgSize = {width: 60, height: 85}
            if (this.$refs.gMap) {
              this.vehicleMarker = this.$refs.gMap.addSingleMaker(this.vehiclePoint, imgSize, null, null)
            }
            this.setMarkInfo()
          }

          // this.$refs.gMap.plannRoute(passPoints)
          this.$refs.gMap.plannRoute(stopPoints)
          if (this.$refs.gMap) {
            setTimeout(() => {
              this.$refs.gMap.map.setCenter(this.centerPoint)
            }, 500)
          }
        })
      })
      // 存入Session中
      sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
      // 设置title
      this.dialogDelayOption.text = '運行中の' + this.shiftInfo.title + 'が<br/>遅延で遅れることを乗客にお知らせしますか？'
    },
    isTimeOut (oldT, newT) {
      let newTime = moment(newT, 'YYYYMMDDHHmmssSSS')
      let oldTime = moment(oldT, 'YYYYMMDDHHmmssSSS')
      oldTime.add(this.MQ_TIME_OUT, 'seconds')
      if (oldTime.isBefore(newTime)) {
        return true// 过期
      }
      return false// 未过期
    },
    // 返回
    goback () {
      this.$router.push({name: 'MovementStatus'})
    },
    // 跳转到表格详细页面
    goToTable () {
      // ljc
      if (this.shiftInfo.businessStatus === 3) {
        this.$router.push({ path: '/ShiftEndDetail', query: {flag: true, from: 'MovementStatusDetail'} })
      } else {
        this.$router.push({ path: '/ShiftWithEventDetail', query: {flag: true, from: 'MovementStatusDetail',transportKind: this.shiftInfo.transportKind, allConnectShiftsCanEdit: this.allConnectShiftsCanEdit} })
      }
    },
    // 时间转成HH:mm
    HHmm (str) {
      if (str === null || str === '') {
        return ''
      }
      return DateUtil.hourMin(str)
    },
    // 获取乘客对象
    getPassengerNameObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          if (this.shiftInfo.shiftFlag === 0) {
            return {name: reservation.lastName + ' ' + reservation.firstName, nameKana: reservation.lastNameKana + ' ' + reservation.firstNameKana, reservationNote: reservation.note}
          } else {
            return {name: reservation.lastName + ' ' + reservation.firstName, nameKana: reservation.lastNameKana + ' ' + reservation.firstNameKana, reservationNote: reservation.note}
          }
        }
      }
      return {}
    },
    // 获取乘客地址对象
    getPassengerAddressObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          if (this.shiftInfo.shiftFlag === 0) {
            switch (reservation.startPlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:
                return {address: reservation.startStationAddress, stationId: reservation.startStationId, lat: reservation.startStationLat, lng: reservation.startStationLng}
              default:
                return {address: reservation.startPlaceName, stationId: '', lat: reservation.startPlaceLat, lng: reservation.startPlaceLng}
            }
          } else {
            switch (reservation.arrivePlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:

                return {address: reservation.arriveStationAddress, stationId: reservation.arriveStationId, lat: reservation.arriveStationLat, lng: reservation.arriveStationLng}
              default:
                return {address: reservation.arrivePlaceName, stationId: reservation.startStationId, lat: reservation.arrivePlaceLat, lng: reservation.arrivePlaceLng}
            }
          }
        }
      }
      return {}
    },
    // 判断当前经由地是否停车
    isStop (stationId) {
      // 上车乘客
      let startPassengers = []
      // 下车乘客
      let arrivePassengers = []
      let stopFlag = false
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        // 获取停留所上车人
        if (reservation.startStationId === stationId) {
          startPassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + reservation.firstName})
          stopFlag = true
        }
        if (reservation.arriveStationId === stationId) {
          arrivePassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + reservation.firstName})
          stopFlag = true
        }
      }
      return {stopFlag: stopFlag, startPassengers: startPassengers, arrivePassengers: arrivePassengers}
    },
    detailed (shiftPasspoint) {
      // 图标样式
      let vehiclePoint = {
        label: shiftPasspoint.listIndex,
        lat: shiftPasspoint.stationLat,
        lng: shiftPasspoint.stationLng,
        icon: shiftPasspoint.icon
      }
      // 传数据
      this.$refs.saveWindowDiv.viewModel = shiftPasspoint
      var center = {
        lat: shiftPasspoint.stationLat,
        lng: shiftPasspoint.stationLng
      }
      // 设置中心点
      this.$refs.saveWindowDiv.centerPoint = center

      this.$refs.saveWindowDiv.title = '運行状況に戻る'
      this.$refs.saveWindowDiv.markPosition = vehiclePoint
      // 设置缩放
      this.$refs.saveWindowDiv.zoom = 12
      // 加载地图
      this.$refs.saveWindowDiv.initiGoogleMap(shiftPasspoint.labelClass)
    },
    commitServer () {
      this.shiftReservation = JSON.parse(sessionStorage.getItem('shiftReservation'))
      this.shiftReservation.flag = 2
      sessionStorage.setItem('shiftReservation', JSON.stringify(this.shiftReservation))
      if (this.sums < 3) {
        $('.modal-backdrop').remove()
        $('body').removeClass('modal-open')
        this.$router.push({
          path: '/passengerReservation',
          name: 'passengerReservation'
        })
      }
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.showDialog = false
        $('.modal-backdrop').remove()
        $('body').removeClass('modal-open')
        this.$router.push({
          path: '/passengerReservation',
          name: 'passengerReservation'
        })
      }).catch(() => {
        this.showDialog = false
      })
    },
    // 延迟便
    delayShift () {
      let changeDelayFlag = 0
      if (this.shiftInfo.lateFlag === 1) {
        this.dialogDelayOption.text = this.shiftInfo.title + 'の遅延を解除しますか？（乗客に通知が送られます。）'
        changeDelayFlag = 0
      } else {
        this.dialogDelayOption.text = '運行中の' + this.shiftInfo.title + 'が<br/>遅延で遅れることを乗客にお知らせしますか？'
        changeDelayFlag = 1
      }
      this.showDelayDialog = true
      this.$refs.delayDialog.confirm().then(() => {
        let param = this.$qs.stringify({shiftId: this.shiftInfo.shiftId, delayFlag: changeDelayFlag})
        this.$axios.post('shift/updateLateFlag', param)
          .then((response) => {
            this.shiftInfo.lateFlag = changeDelayFlag

            if (this.vehicleMarker) {
              this.vehiclePoint.lateFlag = changeDelayFlag
              // 判断通信异常
              let nowTime = moment().format('YYYYMMDDHHmmssSSS')
              if (this.isTimeOut(this.vehiclePoint.pTime, nowTime) || this.isTimeOut(this.vehiclePoint.mTime, nowTime)) {
                this.vehiclePoint.communicationFlag = 1
              }
              this.drawVehiclePoint()
            }
          })
          .catch(function (error) {
            console.log(error)
          })

        this.showDelayDialog = false
      }).catch(() => {
        this.showDelayDialog = false
      })
    },
    // 强制终了便
    endShift () {
      this.showEndDialog = true
      this.$refs.endDialog.confirm().then(() => {
        let param = this.$qs.stringify({shiftId: this.shiftInfo.shiftId})
        this.$axios.post('shift/updateCoercionStopFlag', param)
          .then((response) => {
            this.$router.push({name: 'MovementStatus'})
          })
          .catch(function (error) {
            console.log(error)
          })
        this.showEndDialog = false
      }).catch(() => {
        this.showEndDialog = false
      })
    },
    getMQMess () {
      var url = this.MQ_URL
      var login = this.MQ_LOGIN
      var passcode = this.MQ_PASSCODE
      var destination = '/topic/' + this.MQ_DESTINATION
      // 本地测试
      // var url = 'ws://127.0.0.1:61614?maximumConnections=1000&amp;wireFormat.maxFrameSize=104857600'
      // var login = 'admin'
      // var passcode = 'admin'
      // var destination = '/topic/TransportationServiceQueue'

      this.client = Stomp.client(url, CommonConstant.MQ_STOMP_CLIENT)
      this.client.heartbeat.outgoing = 10000
      this.client.heartbeat.incoming = 0
      this.client.connect(login, passcode, frame => {
        this.client.subscribe(destination, message => {
          let mess = JSON.parse(message.body)
          console.log(mess)
          switch (mess.type) {
            case 1:
              this.updateVehiclePosition(mess)
              break
            case 2:
              this.updateTrouble(mess)
              break
            case 3:
              this.updateToMoveStart(mess)
              break
            case 4:
              if (this.shiftInfo.businessStatus !== 2) {
                break
              }
              this.updateToArriveTime(mess)
              break
            case 5:
              this.updateToMoveEnd(mess)
              break
            case 6:
              this.updateToBusinessStart(mess)
              break
            case 7:
              this.updateToBusinessEnd(mess)
              break
          }
        })
      })
    },
    // 更新车辆位置
    updateVehiclePosition (mess) {
      // 更新位置
      if (this.shiftInfo.shiftId === mess.data.shiftId && this.vehiclePoint === null) {
        this.vehiclePoint = {
          shiftId: this.shiftInfo.shiftId,
          label: null,
          lat: mess.data.position.lat,
          lng: mess.data.position.lng,
          // 延迟标志 1延迟 0正常
          lateFlag: this.shiftInfo.lateFlag,
          // 故障标志 1故障 0正常
          troubleFlag: this.shiftInfo.troubleFlag,
          // 是否更新 用于判断通信是否成功
          communicationFlag: 0,
          // 位置更新时间
          pTime: mess.data.position.time,
          // MQ接收时间
          mTime: moment().format('YYYYMMDDHHmmssSSS'),
          // 故障时间
          tTime: null,
          // 点的图标
          icon: null,
          iconSize: null
        }
        this.drawVehiclePoint()
      } else if (this.vehiclePoint.shiftId === mess.data.shiftId) {
        this.vehiclePoint.lat = mess.data.position.lat
        this.vehiclePoint.lng = mess.data.position.lng
        // 判断通信异常
        let mqTime = moment().format('YYYYMMDDHHmmssSSS')
        if (this.isTimeOut(this.vehiclePoint.mTime, mqTime)) {
          this.vehiclePoint.communicationFlag = 1
        } else {
          this.vehiclePoint.communicationFlag = 0
        }

        this.vehiclePoint.pTime = mess.data.position.time
        this.vehiclePoint.mTime = mqTime

        console.log('MQ lat=' + this.vehiclePoint.lat + ',lng=' + this.vehiclePoint.lng)

        this.drawVehiclePoint()
      }
    },
    // 更新障害
    updateTrouble (mess) {
      // 更新trouble
      if (this.vehiclePoint.shiftId === mess.data.shiftId) {
        this.vehiclePoint.troubleFlag = 1
        // // 判断通信异常
        let mqTime = moment().format('YYYYMMDDHHmmssSSS')
        // if (this.isTimeOut(this.vehiclePoint.pTime, mess.data.position.time) || this.isTimeOut(this.vehiclePoint.mTime, mqTime)) {
        //   this.vehiclePoint.communicationFlag = 1
        // } else {
        //   this.vehiclePoint.communicationFlag = 0
        // }
        this.vehiclePoint.tTime = mqTime
        this.vehiclePoint.mTime = mqTime
        this.drawVehiclePoint()

        this.playVideo(tblMP3)
      }
    },
    // 运行开始
    updateToMoveStart (mess) {
      if (this.shiftInfo.shiftId === mess.data.shiftId) {
        this.shiftInfo.shiftMovementStatus = 2
        this.shiftInfo.vehicleLat = mess.data.position.lat
        this.shiftInfo.vehicleLng = mess.data.position.lng
        this.$axios.get('shift/queryPassPointActualTime', {params: {shiftId: this.shiftInfo.shiftId}})
          .then(response => {
            let shiftPasspointInfos = response.data.shiftPasspointInfos
            let k = 0
            for (let i = 0; i < this.shiftPasspoints.length; i++) {
              if (shiftPasspointInfos[i].arriveActualTime) {
                this.shiftInfo.shiftPasspoints[i].arriveActualTime = shiftPasspointInfos[i].arriveActualTime
                this.shiftPasspoints[i].actualTime = shiftPasspointInfos[i].arriveActualTime
                k = i
              }
            }
            // 滯空原來的點
            for (let marker of this.markers) {
              marker.setMap(null)
            }
            // 修改到達點的ICON
            for (let p = 0; p <= k; p++) {
              if (this.pointDataList[p].icon === STATION_ICON_1 || this.pointDataList[p].icon === STATION_ICON_2) {
                this.pointDataList[p].icon = STATION_ICON_2
              } else if (this.pointDataList[p].icon === USER_ICON_1 || this.pointDataList[p].icon === USER_ICON_2) {
                this.pointDataList[p].icon = USER_ICON_2
              } else {
                this.pointDataList[p].icon = STATION_NO_ICON_2
              }
              this.pointDataList[p].labelClass = 'station-label-class-2'
            }
            // 重新劃點
            let imgSize = {width: 45, height: 60}
            let labelAnchor = {width: 22, height: 50}
            this.markers = this.$refs.gMap.addMark(imgSize, null, labelAnchor)
            this.playVideo(msgMP3)
            // 存入Session中
            sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // 到达
    updateToArriveTime (mess) {
      // 更新實際到達時間
      if (this.shiftInfo.shiftId === mess.data.shiftId) {
        let shiftId = this.$route.query.shiftId
        this.$axios.get('shift/queryPassPointActualTime', {params: {shiftId: shiftId}})
          .then(response => {
            let shiftPasspointInfos = response.data.shiftPasspointInfos
            let k = -1
            for (let i = 0; i < this.shiftPasspoints.length; i++) {
              if (shiftPasspointInfos[i].arriveActualTime) {
                this.shiftInfo.shiftPasspoints[i].arriveActualTime = shiftPasspointInfos[i].arriveActualTime
                this.shiftPasspoints[i].actualTime = shiftPasspointInfos[i].arriveActualTime
                k = i
              }
            }
            // 滯空原來的點
            for (let marker of this.markers) {
              marker.setMap(null)
            }
            // 修改到達點的ICON
            for (let p = 0; p <= k; p++) {
              if (this.pointDataList[p].icon === STATION_ICON_1 || this.pointDataList[p].icon === STATION_ICON_2) {
                this.pointDataList[p].icon = STATION_ICON_2
              } else if (this.pointDataList[p].icon === USER_ICON_1 || this.pointDataList[p].icon === USER_ICON_2) {
                this.pointDataList[p].icon = USER_ICON_2
              } else {
                this.pointDataList[p].icon = STATION_NO_ICON_2
              }
              this.pointDataList[p].labelClass = 'station-label-class-2'
            }
            // 重新劃點
            let imgSize = {width: 45, height: 60}
            let labelAnchor = {width: 22, height: 50}
            this.markers = this.$refs.gMap.addMark(imgSize, null, labelAnchor)
            // 存入Session中
            sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
          })
          .catch(error => {
            console.log(error)
          })
        if (this.vehiclePoint) {
          this.vehiclePoint.communicationFlag = 0
        }
        this.playVideo(msgMP3)
      }
    },
    // 运行结束
    updateToMoveEnd (mess) {
      if (this.shiftInfo.shiftId === mess.data.shiftId) {
        this.shiftInfo.shiftMovementStatus = 3
        let shiftId = this.$route.query.shiftId
        this.$axios.get('shift/queryPassPointActualTime', {params: {shiftId: shiftId}})
          .then(response => {
            let shiftPasspointInfos = response.data.shiftPasspointInfos
            let k = -1
            for (let i = 0; i < this.shiftPasspoints.length; i++) {
              if (shiftPasspointInfos[i].arriveActualTime) {
                this.shiftInfo.shiftPasspoints[i].arriveActualTime = shiftPasspointInfos[i].arriveActualTime
                this.shiftPasspoints[i].actualTime = shiftPasspointInfos[i].arriveActualTime
                k = i
              }
            }
            // 滯空原來的點
            for (let marker of this.markers) {
              marker.setMap(null)
            }
            // if (this.vehicleMarker) {
            //   this.vehicleMarker.setMap(null)
            // }
            // 修改到達點的ICON
            // 修改到達點的ICON
            for (let p = 0; p <= k; p++) {
              if (this.pointDataList[p].icon === STATION_ICON_1 || this.pointDataList[p].icon === STATION_ICON_2) {
                this.pointDataList[p].icon = STATION_ICON_2
              } else if (this.pointDataList[p].icon === USER_ICON_1 || this.pointDataList[p].icon === USER_ICON_2) {
                this.pointDataList[p].icon = USER_ICON_2
              } else {
                this.pointDataList[p].icon = STATION_NO_ICON_2
              }
              this.pointDataList[p].labelClass = 'station-label-class-2'
            }
            // 重新劃點
            let imgSize = {width: 45, height: 60}
            let labelAnchor = {width: 22, height: 50}
            this.markers = this.$refs.gMap.addMark(imgSize, null, labelAnchor)
            this.playVideo(msgMP3)
            // 存入Session中
            sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // 业务开始
    updateToBusinessStart (mess) {
      if (this.shiftInfo.shiftId === mess.data.shiftId) {
        this.shiftInfo.businessStatus = 2
        this.shiftInfo.vehicleLat = mess.data.position.lat
        this.shiftInfo.vehicleLng = mess.data.position.lng
        this.$axios.get('shift/queryPassPointActualTime', {params: {shiftId: this.shiftInfo.shiftId}})
          .then(response => {
            let shiftPasspointInfos = response.data.shiftPasspointInfos
            let k = -1
            for (let i = 0; i < this.shiftPasspoints.length; i++) {
              if (shiftPasspointInfos[i].arriveActualTime) {
                this.shiftInfo.shiftPasspoints[i].arriveActualTime = shiftPasspointInfos[i].arriveActualTime
                this.shiftPasspoints[i].actualTime = shiftPasspointInfos[i].arriveActualTime
                k = i
              }
            }
            // 滯空原來的點
            for (let marker of this.markers) {
              marker.setMap(null)
            }
            // 修改到達點的ICON
            for (let p = 0; p <= k; p++) {
              if (this.pointDataList[p].icon === STATION_ICON_1 || this.pointDataList[p].icon === STATION_ICON_2) {
                this.pointDataList[p].icon = STATION_ICON_2
              } else if (this.pointDataList[p].icon === USER_ICON_1 || this.pointDataList[p].icon === USER_ICON_2) {
                this.pointDataList[p].icon = USER_ICON_2
              } else {
                this.pointDataList[p].icon = STATION_NO_ICON_2
              }
              this.pointDataList[p].labelClass = 'station-label-class-2'
            }
            // 重新劃點
            let imgSize = {width: 45, height: 60}
            let labelAnchor = {width: 22, height: 50}
            this.markers = this.$refs.gMap.addMark(imgSize, null, labelAnchor)
            this.playVideo(msgMP3)
            // 存入Session中
            sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // 业务结束
    updateToBusinessEnd (mess) {
      if (this.shiftInfo.shiftId === mess.data.shiftId) {
        this.shiftInfo.businessStatus = 3
        let shiftId = this.$route.query.shiftId
        this.$axios.get('shift/queryPassPointActualTime', {params: {shiftId: shiftId}})
          .then(response => {
            let shiftPasspointInfos = response.data.shiftPasspointInfos
            for (let i = 0; i < this.shiftPasspoints.length; i++) {
              this.shiftInfo.shiftPasspoints[i].arriveActualTime = shiftPasspointInfos[i].arriveActualTime
              this.shiftPasspoints[i].actualTime = shiftPasspointInfos[i].arriveActualTime
            }
            // 滯空原來的點
            for (let marker of this.markers) {
              marker.setMap(null)
            }
            if (this.vehicleMarker) {
              this.vehicleMarker.setMap(null)
              this.vehicleMarker = null
            }
            // 修改到達點的ICON
            for (let p = 0; p < this.pointDataList.length; p++) {
              if (this.pointDataList[p].icon === STATION_ICON_1 || this.pointDataList[p].icon === STATION_ICON_2) {
                this.pointDataList[p].icon = STATION_ICON_2
              } else if (this.pointDataList[p].icon === USER_ICON_1 || this.pointDataList[p].icon === USER_ICON_2) {
                this.pointDataList[p].icon = USER_ICON_2
              } else {
                this.pointDataList[p].icon = STATION_NO_ICON_2
              }
              this.pointDataList[p].labelClass = 'station-label-class-2'
            }
            // 重新劃點
            let imgSize = {width: 45, height: 60}
            let labelAnchor = {width: 22, height: 50}
            this.markers = this.$refs.gMap.addMark(imgSize, null, labelAnchor)
            this.playVideo(msgMP3)
            // 存入Session中
            sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    playVideo (mp3) {
      let video = new Audio(mp3)
      try {
        video.play()
      } catch (error) {
        console.error(error)
      }
    },
    drawVehiclePoint () {
      if (this.vehicleMarker) {
        this.vehicleMarker.setMap(null)
      }

      // 根据不同状态修改点的图标
      if (this.vehiclePoint.communicationFlag === 1) {
        this.vehiclePoint.icon = RADIO_TROUBLE_POSITION_ICON
        this.vehiclePoint.iconSize = {
          width: 60,
          height: 85
        }
      } else if (this.vehiclePoint.lateFlag === 1) {
        this.vehiclePoint.icon = DELAY_POSITION_ICON
        this.vehiclePoint.iconSize = {
          width: 60,
          height: 120
        }
      } else if (this.vehiclePoint.troubleFlag === 1) {
        this.vehiclePoint.icon = TROUBLE_POSITION_ICON
        this.vehiclePoint.iconSize = {
          width: 60,
          height: 120
        }
      } else {
        this.vehiclePoint.icon = NORMAL_POSITION_ICON
        this.vehiclePoint.iconSize = {
          width: 60,
          height: 85
        }
      }
      // // 设置中心点
      // if (this.vehiclePoint) {
      //   this.centerPoint = {
      //     lat: this.vehiclePoint.lat,
      //     lng: this.vehiclePoint.lng
      //   }
      //   if (this.$refs.gMap) {
      //     this.$refs.gMap.map.setCenter(this.centerPoint)
      //   }
      // }
      let labelAnchor = {width: 30, height: 45}
      if (this.$refs.gMap) {
        this.vehicleMarker = this.$refs.gMap.addSingleMaker(this.vehiclePoint, null, null, labelAnchor)
      }

      this.setMarkInfo()
    },
    setMarkInfo () {
      for (let infowindow of this.infowindowList) {
        infowindow.close()
      }
      this.infowindowList = []
      // 通信障害时提示
      if (this.vehiclePoint.icon === RADIO_TROUBLE_POSITION_ICON) {
        // 定义信息
        var infowindow = new global.google.maps.InfoWindow({
          content: '車両の通信状態が不安定です。'
        })
        if (this.$refs.gMap) {
          infowindow.open(this.$refs.gMap.map, this.vehicleMarker)
          this.infowindowList.push(infowindow)
        }
      }
    },
    checkMoveShiftStatus (shiftInfo) {
      // 判断是否强制终了
      if (shiftInfo.coercionStopFlag === 1) {
        return 4
      }

      return shiftInfo.businessStatus
    },
    // 区域外対応
    // 親便IDを取得
    getParentShiftId (){
      console.log("getParentShiftId")
      let parentShiftId
      if(this.shiftInfo.parentShiftId == '' || this.shiftInfo.parentShiftId == null){
        parentShiftId = this.shiftInfo.shiftId
      }else{
        parentShiftId = this.shiftInfo.parentShiftId
      }
      console.log(parentShiftId)
      return parentShiftId
    },

    // 停留所が接続されている便を取得し、停留所一覧と紐付ける
    setConnectList () {
      console.log('setConnectList')
      let parentShiftId = this.getParentShiftId()

      // 便一覧を取得
      let shiftList = []
      this.$axios.get('shift/queryShiftInfoListByParentShiftId', {params: {parentShiftId: parentShiftId}}).then(response => {
        let shiftInfoList
        let shift = {}
        console.log("queryShiftInfoListByParentShiftId")
        console.log(response.data.shiftInfoList)
        shiftInfoList = response.data.shiftInfoList
        for (let shiftInfoTemp of shiftInfoList) {
          shift = {}
          shift.shiftId = shiftInfoTemp.shiftId
          shift.shiftTitle = shiftInfoTemp.title
          shiftList.push(shift)
          
          // 接続便の状態チェック
          if(shiftInfoTemp.businessStatus == 2){
            console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務開始」です")
            this.allConnectShiftsCanEdit = false
          }else if(shiftInfoTemp.businessStatus == 3){
            console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務終了」です")
            this.allConnectShiftsCanEdit = false
          }
        }

        console.log("shiftList")
        console.log(shiftList)

        // 接続をすべて取得し、停留所一覧と紐付ける
        this.$axios.get('shift/queryShiftConnectList', {params: {parentId: parentShiftId}}).then(response => {
          console.log(response.data)
          for(let i=0; i < response.data.shiftConnectList.length; i++){
            let shiftConnectTemp = {
                frontShiftConnect: {
                  shiftId: '0000',
                  connectSourceShiftId: '0000',
                  stationId: '',
                  connectSourceStationId: '',
                  stationTime: '',
                  connectSourceStationTime: '',
                  stationUseTime: 0,
                  errorMessage: '',
                  timeError: 0
                },
                shiftConnect: {
                },
              }
            shiftConnectTemp.frontShiftConnect = response.data.shiftConnectList[i]
            shiftConnectTemp.shiftConnect = response.data.shiftConnectList[i]
            this.shiftConnectList.push(shiftConnectTemp)
          }
          this.isLoading = false

          let connect = {}
          let duplicateFlag = false
          for(let i = 0; i < this.shiftPasspoints.length; i++){
            this.shiftPasspoints[i].connectList = []
            for(let j= 0; j < this.shiftConnectList.length; j++){
              duplicateFlag = false
              // 接続一覧からページ内の停留所と一致する停留所を探し、その接続の便名とIDを取得する
              // 接続元の場合
              if(this.shiftPasspoints[i].stationId == this.shiftConnectList[j].frontShiftConnect.connectSourceStationId){
                connect = {}
                connect.shiftId = this.shiftConnectList[j].frontShiftConnect.shiftId
                // 便名取得
                for(let k = 0; k < shiftList.length; k++){
                  if(shiftList[k].shiftId == connect.shiftId){
                    connect.shiftTitle = '接続先 ' + shiftList[k].shiftTitle
                  }
                }
                // this.shiftPasspoints[i].connectList.push(connect)
                // 重複チェック
                for(let j = 0; j < this.shiftPasspoints[i].connectList.length; j++){
                  if(this.shiftPasspoints[i].connectList[j].shiftId == connect.shiftId){
                    duplicateFlag = true 
                  }
                }
                if(!duplicateFlag){
                  this.shiftPasspoints[i].connectList.push(connect)
                }
              }
              // 接続先の場合
              if(this.shiftPasspoints[i].stationId == this.shiftConnectList[j].frontShiftConnect.stationId){
                connect = {}
                connect.shiftId = this.shiftConnectList[j].frontShiftConnect.connectSourceShiftId
                // 便名取得
                for(let k = 0; k < shiftList.length; k++){
                  if(shiftList[k].shiftId == connect.shiftId){
                    connect.shiftTitle = '接続元 ' + shiftList[k].shiftTitle
                  }
                }
                // this.shiftPasspoints[i].connectList.push(connect)
                // 重複チェック
                for(let j = 0; j < this.shiftPasspoints[i].connectList.length; j++){
                  if(this.shiftPasspoints[i].connectList[j].shiftId == connect.shiftId){
                    duplicateFlag = true 
                  }
                }
                if(!duplicateFlag){
                  this.shiftPasspoints[i].connectList.push(connect)
                }
              }
            }
          }
          // 描画更新
          this.shiftPasspoints.splice(0,this.shiftPasspoints)
          console.log("this.shiftPasspoints")
          console.log(this.shiftPasspoints)
        })
      })
    },

    // 接続便の詳細ボタンクリック時の動作
    goToConnectShift(index){
      if(this.shiftPasspoints[index].shiftId != null || this.shiftPasspoints[index].shiftId != ''){
        this.$router.push({ path: '/MovementStatusDetail', query: {shiftId: this.shiftPasspoints[index].shiftId} })
      }
    }

  },
  beforeRouteLeave (to, from, next) {
    if (this.client && this.client.connected) {
      this.client.disconnect()
    }
    next()
  }
}
</script>

<template>
<MainLayout>
  <div class="body">
    <!-- header -->
    <div class="row clearfix header">
      <div class="col-md-2 column headerleft">
        <input type="button" class="F1-R-19" :value="backName"  @click="goback"/>
      </div>
      <div class="col-md-8 column headermiddle F3-M-27">
        運行状況
      </div>

      <div class="col-md-4 column headerright" >
            <button class="btn move-status-btn F2-R-19" v-if="shiftInfo.businessStatus!==2" >強制終了</button>
            <button class="btn move-status-btn F2-R-19" v-else @click="endShift">強制終了</button>
            <button class="btn move-status-btn F2-R-19 delay-bg-class1" v-if="shiftInfo.businessStatus!==2" >遅延</button>
            <button class="btn move-status-btn" :class="shiftInfo.lateFlag!==1?'delay-bg-class1':'delay-bg-class2'" v-else @click="delayShift">遅延</button>
      </div>
    </div>
    <!-- body -->
    <div class="col-md-12 column">
        <div class="row clearfix">
          <div class="col-md-5 column homeLeft slider">
              <div class="homeleftdetail">
                <!-- title -->
                <div>
                  <div class="home-title" :class="titleBg[status-1]">
                    <div class="col-md-6 column home-title-left home-time F2-M-20">
                      <div class="shift-title" :title="shiftInfo.title">
                        <img src="../../assets/icon/transport_kind0.png" style="height: 32px;width:32px;" v-if="shiftInfo.transportKind=='0'">
                        <img src="../../assets/icon/transport_kind1.png" style="height: 32px;width:32px;" v-if="shiftInfo.transportKind=='1'">
                        <img src="../../assets/icon/app_use.png" style="height: 32px;width:32px;" v-if="shiftInfo.routeType=='1'">
                        <img src="../../assets/icon/app_dontuse.png" style="height: 32px;width:32px;" v-if="shiftInfo.routeType=='2'">
                        {{shiftInfo.title}}
                      </div>
                    </div>
                    <div class="col-md-6 column home-title-right F2-M-20">{{shiftMovementStatus[status-1]}}</div>
                  </div>
                  <div class="home-content" :class="['statusBorder'+status,contentBg[status-1]]">
                    <div class="home-frist">
                      <div class="home-title-left home-time">
                        <span class="tooLong driver-key F3-M-16">[ドライバー]</span>
                        <span class="tooLong driver-value F3-M-22" :title="shiftInfo.driverLastName+' '+shiftInfo.driverFirstName">&nbsp;{{shiftInfo.driverLastName}}&nbsp;{{shiftInfo.driverFirstName}}</span>
                        <!-- v-show="this.vehiclePoint&&this.vehiclePoint.communicationFlag==1&&shiftInfo.lateFlag!==1" -->
                        <img  v-show="showGpsNotReach" src="../../assets/map_icon/map_gps_not_reach.png" style="height:40px;position: absolute;right: 0px;"/>
                        <img  v-show="shiftInfo.lateFlag===1" src="../../assets/delay_mark_mid.png" style="height:25px;position: absolute;right: 0px;"/>
                      </div>
                      <div class="detail-div">
                          <button class="btn detail-btn F2-M-16" @click.stop="goToTable">詳細</button>
                      </div>
                    </div>
                    <div class="col-md-12 column home-content-div">
                      <div class="home-title-left home-time">
                        <div class="col-md-3 column div-style">
                          <span class="F3-R-17">車両ID : {{shiftInfo.displayVehicleId}}</span>
                        </div>
                        <div class="col-md-3 column vehicle-name F3-R-17" :title="shiftInfo.vehicleName">
                            車両 : {{shiftInfo.vehicleName}}
                        </div>
                        <div class="col-md-3 column div-style">
                          <span class="F3-R-17">定員 : {{shiftInfo.passengerNumber}}名</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="clearfix" style="height:0px"></div>
              <!-- 经由地 -->
              <!-- <div class="clearfix list-item bgc5" v-for="(shiftPasspoint,index) in shiftPasspoints" :key="index"
              :style="shiftPasspoint.showPassengers?'height:100px':'height:80px'"> -->
              <div class="clearfix list-item bgc5" v-for="(shiftPasspoint,index) in shiftPasspoints" :key="index"
              style="height: fit-content; position:relative;">
                <div class="list-item-index">
                  <div class="list-bar bgc6" :class="{'list-bar-s':index===0,'list-bar-g':index===shiftPasspoints.length-1}" ></div>
                  <div class="list-index">
                    <!-- 圆圈 -->
                    <div class="F2-R-20" :class="[(shiftPasspoint.listIndex==='S'||shiftPasspoint.listIndex==='G')&&shiftPasspoint.officeFlag===1?'radio-office':'radio']" v-if="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1" style="z-index:99">
                        <span class="radio-index">{{shiftPasspoint.listIndex}}</span>
                    </div>
                    <div class="F2-R-20 radio-none" v-else style="z-index:99">

                    </div>
                  </div>
                </div>
                <div class="list-item-main">
                  <div
                  :href="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'#modal-container-station-dialog':'javascript:void(0)'"
                  class="list-item-detail"
                  @click="detailed(shiftPasspoint)" data-toggle="modal">
                    <!-- 预定时间 -->
                    <div class="col-md-2 column list-time" :class="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'F6-R-24':'F8-R-24'">
                      {{HHmm(shiftPasspoint.estimateTime)}}
                    </div>

                    <div class="col-md-6 column list-content">
                      <!-- 点名 -->
                      <div class="row clearfix">
                        <div class="col-md-12 column list-name"
                        :class="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'F1-R-20':'F7-R-20'"
                        :title="shiftPasspoint.name">
                          <img src="../../assets/icon/office_flag1.png" style="margin:-2px 4px 0 0; height: 32px;width:32px;" v-if="shiftPasspoint.officeFlag=='1'">
                          <div style="margin:-2px 4px 0 0; height: 32px;width:32px;" v-else></div>
                          {{shiftPasspoint.name}}
                        </div>
                      </div>
                      <!-- 地址 -->
                      <div class="row clearfix">
                        <div class="col-md-12 column list-address"
                        :class="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'F3-R-15':'F7-R-15'"
                        :title="shiftPasspoint.address">
                          {{shiftPasspoint.address}}
                        </div>
                      </div>
                      <!-- 停留所显示预约人 -->
                      <div class="row clearfix" v-if="shiftPasspoint.showPassengers">
                        <div class="col-md-12 column F3-R-15 tooLong">
                          乗車者:<span v-for="(passenger,k) in shiftPasspoint.startPassengers" :key="k" class="F3-R-15">{{passenger.name}}<span v-if="k!=shiftPasspoint.startPassengers.length-1">、</span></span>
                        </div>
                      </div>
                    </div>
                    <!-- 到着时间 -->
                    <div class="col-md-2 column list-right" v-if="shiftPasspoint.actualTime!=null&&shiftPasspoint.actualTime!=''&&shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1">
                      <div class="clearfix">
                        <div class="col-md-12 column" style="padding:0 5%">
                          <div v-if="index==0" class="list-status bgc1">出発</div>
                          <div v-else class="list-status bgc1">到着</div>
                        </div>
                      </div>
                      <div class="clearfix">
                        <div class="col-md-12 column list-true-time">
                          {{HHmm(shiftPasspoint.actualTime)}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 接続一覧 -->
                  <div class="list-connect" v-if="shiftPasspoint.connectList.length > 0">
                    <div class="list-connect-title">
                      乗り換えあり
                    </div>
                    <div class="list-connect-select">
                      <select class="selectstyles selectImg" @click.stop v-model="shiftPasspoint.shiftId">
                        <option :value="connect.shiftId" :key="index" v-for="(connect, index) in shiftPasspoint.connectList">
                          {{connect.shiftTitle}}
                        </option>
                      </select>
                    </div>
                    <div class="detail-div">
                        <button class="btn detail-btn F2-M-16" :disabled="shiftPasspoint.shiftId==null" @click.stop="goToConnectShift(index)">詳細</button>
                    </div>
                  </div>
                </div>
              </div>

          </div>
          <div class="col-md-7 column homeRight">
            <googleMap ref="gMap"
              :center-point="centerPoint"
              :map-id="mapId"
              :point-list="pointDataList"
            />
          </div>
        </div>
      </div>
      <MovementDetailedConfirm ref="saveWindowDiv"></MovementDetailedConfirm>
      <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
      <v-dialog v-show="showDelayDialog" :dialog-option="dialogDelayOption" ref="delayDialog"></v-dialog>
      <v-dialog v-show="showEndDialog" :dialog-option="dialogEndOption" ref="endDialog"></v-dialog>
  </div>
</MainLayout>
</template>

<style scoped>
@import "../../assets/css/C00.css";

/* .vehicle-span{
  font-size: 15px;
} */
.text-color1{
  color:rgb(162, 162, 162)
}
.text-color2{
  color:#333
}
.add-reserve-div{
  padding: 0px;
  width: 15%;
  height: 100%;
  position: relative;
}
.add-reserve{
  height: 40px;
  width: 40px;
  position: absolute;
  top:50%;
  left:50%;
  margin-top: -20px;
  margin-left: -20px;
}
.reserve-blank{
  padding: 0px;
  width: 15%;
}
.reserve-title{
  line-height: 75px;
  padding: 0px;
  width: 50%;
  text-align: left;
}
.reserve-person{
  width: 20%;
  height: 100%;
  position: relative;
}
.person-div{
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 30px;
  margin-left: -30px;
  margin-top: -15px;
}
.list-item{
  border-bottom: #B9B9B9 solid 1px;
  border-top: #fff solid 1px;
  background: #DCDCDC;
  margin: 0px auto;
  padding: 5px 0;
  height: 80px;
  display: flex;
  /* flex-direction: column; */
}
.list-item-index{
  width: 15%;
  position: relative;
}
.list-item-main{
  width: 85%;
  cursor:pointer;
  display: flex;
  flex-direction: column;
}
/* 经由地编号 */
.list-index {
  font-size: 20px;
  padding: 0px;
  /* width: 15%; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.list-bar {
  margin-top: -10px;
  position: absolute;
  left: calc(50% - 2px);
  height: calc(100% + 15px);
  width: 4px;
}
.list-bar-s {
  top: 50%;
  height: calc(50% + 15px);
}
.list-bar-g {
  height: calc(50% + 15px);
}
.radio {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #48a3be;
  background-color: #48a3be;
}
.radio-office {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #48a3be;
  background-color: #FFF;
  color: #48a3be!important;
}
.radio-none {
  width: 36px;
  height: 36px;
  background: url('../../assets/operation_list/non_stop_point1.png')
}
.radio-index{
  display: block;
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-weight: bold!important;
}

.index-div{
  position: absolute;
  height: 40px;
  width: 40px;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: -20px;
}
.list-time{
  padding: 0px;
  font-size: 24px;
  width: 18%;
  height: 100%;
  display: flex;
  align-items: center;
}
.list-content{
  text-align: left;
  padding:0px;
  width: 57%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list-name{
  font-size: 24px;
  height: 34px;
  padding-right: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}
.list-address{
  font-size: 14px;
  height: 20px;
  padding-right: 0px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-right{
  padding: 0px;
  width: 25%;
}
.list-status{
  font-size: 15px;
  border: 0;
  height: 20px;
  width: 100%;
  border-radius: 10px;
  background: rgb(141, 141, 141);
  color: #fff;
  padding: 0px;
  margin: 7px 0;
}
.list-true-time{
  padding: 0px;
  font-size: 24px;
  height: 34px;
}

.header{
    margin-bottom: 2vh;
    height: 6vh;
    position: relative;
  }
.headerleft {
  margin-top: 20px;
  margin-left: 1.9%;
  width: 250px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
  z-index: 999;
  /* border: solid 2px #ccc;
  border-radius: 20px; */
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  height: 40px;
  text-align: left;
  width: 100%;
  text-indent: 30px;
}
.headermiddle {
  margin-top: 20px;
  font-size: 24px;
  position: absolute;
  width: 100%;
}
.headerright{
  float: right;
  margin-top: 20px;
  margin-right: 20px;
}
.body{
  display:flex;
  flex-direction:column;
}
.map_container {
  margin-top: 50px;
  width: 100%;
  height: 580px;
}
.homeLeft {
  width: 39%;
  height: 72vh;
  /* 规定元素生成的框的类型 */
  display: inline-block;
  padding-right: 20px;
}
.homeleftdetail{
  margin-top:10px;
}

.middle-content{
  width: 20%;
}

.div-style{
  padding: 0px;
}
.vehicle-name{
  width:40%;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0px;
}
.homeTip{
  background:rgb(210, 210, 210);
  height: 40px;
  font-size: 18px;
}
.status-btn{
  float: right;
  font-size: 15px;
  border: 0;
  height: 26px;
  width: 90px;
  border-radius: 13px;
  background: rgb(141, 141, 141);
  margin: 7px;
  color: #fff;
}
.reserve-div{
  background: rgb(139, 139, 139);
  color: #ffffff;
  height: 75px;
  padding: 0;
  font-size: 18px;
}
.homeContent{
  height: 90px;
  font-size: 18px;
  text-align: left;
  padding: 0 7px;
  cursor:pointer;
  border: rgb(139, 139, 139) solid 2px;
}

.shift-title{
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.detail-btn{
  color:#fff;
  font-size:16px;
  height:32px;
  width:90px;
  border-radius:8px;
  float:right;
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
  border: 0px;
}

.homefrist{
  height: 60%;
  border-bottom: 1px dashed rgb(171, 171, 171);
  display: flex;
  align-items: center;
}
.homeul{
  list-style-type: none;
  width: auto;
  background: #cecece;
  color: black;
  height: 80px;
  margin: 0px;
  padding: 0px;
  padding-top: 5px;
  text-align: left;
  padding-left: 5px;
}
.homeul li{
  float: left;
  padding-left: 20px;
}
.homeRight{
  padding-top: 10px;
  width: 61%;
  height: 72vh;
}
.person-img{
  height:25px;
  width: 15px;
  margin-top: 5%;
}
a{
text-decoration:none;
}
.move-status-btn{
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
  height: 40px;
  border: 0px;
  border-radius: 5px;
  margin: 0 5px;
  color: #fff;
  font-size: 18px;
  width: 32.2%;
  float:right;
}

.delay-bg-class1{
  background: url(../../assets/button/delay_button_off.png);
  font-family: 'Noto Sans CJK JP' !important;
  color: rgb(255, 255, 255) !important;
  font-size: 19px !important;
  font-weight: 400 !important;
  background-repeat: no-repeat;
}

.delay-bg-class2{
  background: url(../../assets/button/delay_button_on.png);
  font-family: 'Noto Sans CJK JP' !important;
  color: rgb(0, 0, 0) !important;
  font-size: 19px !important;
  font-weight: 400 !important;
  background-repeat: no-repeat;
}

/* title */
.home-title{
  color: #ffffff;
  height: 45px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.home-title-left{
  text-align:left;
  margin: 0;
  line-height: 45px;
  width:80%;
  padding-left: 10px;
  position: relative;
}

.driver-key{
  width: 24%;
}
.driver-value{
  width: 76%;
}

.home-title-right{
  width:20%;
  border-left: #fff solid 1px;
  margin: 10px 0;
  padding: 0px;
}

.home-time{
  float: left;
  display: flex;
  align-items: center;
  height: 100%;
}

.home-content{
  /* background: #E6E6E6; */
  height: 85px;
  font-size: 18px;
  text-align: left;
  cursor:pointer;
  margin-bottom: 5px;
}

.home-content-div{
  font-size: 14px;
  padding: 0px;
  height: 45%;
}

.home-frist{
  height: 55%;
  border-bottom: 1px dashed rgb(171, 171, 171);
  display: flex;
  align-items: center;
}
.tooLong{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detail-div{
  width:20%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.statusBg1{
  background: rgb(108, 162, 188);
}
.statusBg2{
  background: rgb(54, 72, 165);
}
.statusBg3{
  background: rgb(138, 138, 138);
}
.statusBorder1{
  border: rgb(108, 162, 188) 3px solid;
}
.statusBorder2{
  border: rgb(54, 72, 165) 3px solid;
}
.statusBorder3{
  border: rgb(138, 138, 138) 3px solid;
}
.statusBorder4{
  border: rgb(138, 138, 138) 3px solid;
}

 @media screen and (max-device-width: 1480px) {
  .status-btn{
     font-size: 11px;
  }
  .list-name{
    font-size: 20px;
  }
  .list-time{
    font-size: 20px;
  }
  .list-address{
    font-size: 10px;
  }
  .list-status{
    font-size: 11px;
  }
  .list-true-time{
    font-size: 20px;
  }
  
 }
 
</style>
<style lang="scss">
.selectstyles {
  font-size: 18px;
  border: solid 1px #ccc;
  border-radius: 10px;
  width: 100%;
  height: 40px;
  line-height: 20px;
  text-align: left;
  padding-left: 12px;
  padding-right:30px;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../../assets/dropselect.png") no-repeat scroll right center #FFF;
  // background: url("../../assets/dropselect.png") no-repeat scroll right center transparent;
}
.list-connect{
  display: flex;
  align-items: center;

  .list-connect-title{
    font-size: 12px;
    line-height: 40px;
    color: red;
  }

  .list-connect-select{
    margin-left: 4px;
    width: 60%;
  }
  select{
    width: 100%; 
  }

  .detail-btn{
    width: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/router/views/MovementStatusDetail.vue